module.exports = __webpack_public_path__ + "static/img/c23.e18b635.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c23.jpg
// module id = 270
// module chunks = 0 1 2 3 4 5 6 7 8 9